import { useState } from "react";
import { toast } from "sonner";
import { RotateCcw, RotateCw, Loader2 } from "lucide-react";
import { rotateMedia } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Rotate one photo 90 degrees; parent gets the new rotation so every preview re-renders with the corrected image.
export function RotateControls({ horseId, m, onRotated, testId }) {
  const [busy, setBusy] = useState(false);
  const go = async (dir) => {
    setBusy(true);
    try {
      const { rotation } = await rotateMedia(horseId, m.smartsheet_attachment_id, dir);
      onRotated(rotation);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not rotate the photo");
    } finally { setBusy(false); }
  };
  const cls = "h-11 w-11 sm:h-9 sm:w-9";
  return (
    <>
      <Button size="icon" variant="ghost" data-testid={`${testId}-ccw`} disabled={busy} onClick={() => go("ccw")} className={cls} aria-label="Rotate left" title="Rotate left">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />}
      </Button>
      <Button size="icon" variant="ghost" data-testid={`${testId}-cw`} disabled={busy} onClick={() => go("cw")} className={cls} aria-label="Rotate right" title="Rotate right">
        <RotateCw className="h-4 w-4" />
      </Button>
    </>
  );
}
